import {
  AREAS_ERROR,
  AREAS_REQUEST,
  AREAS_SUCCESS,
} from './types';

const initialState = {
  data   : [],
  error  : null,
  loading: false,
};

export { initialState };

export default function (state = initialState, action) {
  switch (action.type) {
    case AREAS_ERROR:
      return {
        ...state,
        error  : action.error,
        loading: false,
      };
    case AREAS_REQUEST:
      return {
        ...state,
        error  : null,
        loading: true,
      };
    case AREAS_SUCCESS:
      return {
        ...state,
        data   : action.data,
        loading: false,
      };
    default:
      return state;
  }
}
